import {CircularProgress} from '@material-ui/core';
import {toEither} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import {pipe} from 'fp-ts/lib/pipeable';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {ReducerState} from 'rootReducer';
import ErrorPage from 'Shared/components/ErrorPage';
import * as IndependentAgentActions from 'Users/ducks/independentAgent';
import {selectUserClaims} from 'Users/selectors/userProfileSelectors';
import './LinkingIndependentAgent.sass';

type LinkingIndependentAgentProps = {
  userKey: string;
} & typeof IndependentAgentActions &
  ReturnType<typeof mapStateToProps>;

const LinkingIndependentAgent = (props: LinkingIndependentAgentProps) => {
  useEffect(() => {
    props.linkAgency(props.username, props.userKey);
  }, [props.userKey]);

  return IndependentAgentActions.LinkAgentState.match(props.linkAgencyState, {
    linkingAgent: () => (
      <div className="link-independent-agent">
        <p>Linking Your Account, Please Wait...</p>
        <CircularProgress />
      </div>
    ),
    linkingError: error => <ErrorPage error={error} />,
  });
};

const mapStateToProps = (state: ReducerState) => ({
  linkAgencyState: state.user.independentAgent.linkAgencyState,
  username: pipe(
    selectUserClaims(state),
    toEither,
    E.fold(
      () => '',
      claims => claims.userName
    )
  ),
});

export default connect(mapStateToProps, {...IndependentAgentActions})(LinkingIndependentAgent);
